import CycleMeasurement from '../enums/cycle-measurement';

const getTempByMeasurement = (measurement: CycleMeasurement, celsius: number): number => {
  if (measurement === CycleMeasurement.Fahrenheit) {
    const fahrenheit = (celsius * 9/5) + 32;

    return Math.round(fahrenheit);
  };

  return Math.round(celsius);
}

export default getTempByMeasurement;
